export interface LegislationItem {
    legislationItemId: number;
    title: string;
    about: string;
    ourPosition: string;
    emailSubject: string;
    createdBySapid: string;
    updatedBySapid: string;
    dateCreated: string | Date;
    dateUpdated: string  | Date;
    isEmailSubjectTitle?: boolean;
    active: boolean;
    trackingLinks?: TrackingLink[];
    resourceLinks?: ResourceLink[];
    talkingPoints?: TalkingPoint[];
    itemRecipients?: LegislationItemRecipient[];
}

export interface TrackingLink {
    trackingLinkId?: number;
    trackingLabel: string;
    displayText?: string;
    trackingLink: string;
    legislationItemId: number;
}

export interface ResourceLink {
    resourceLinkId?: number;
    resourceLabel: string;
    displayText?: string;
    resourceLink: string;
    legislationItemId: number;
}

export interface TalkingPoint {
    talkingPointId?: number;
    legislationItemId: number;
    talkingPoint: string;
}

export class LegislationRecipient {
    recipientId: number;
    name: string;
    // firstName: string;
    // middleName?: string;
    // nickname?: string;
    // lastName: string;
    // prefix?: string;
    // suffix?: string;
    email: string;
    itemRecipients?: LegislationItemRecipient[];
    recipientGroups?: LegislationRecipientGroup[];

    constructor() {
        this.recipientId = 0;
        this.name = '';
        this.email = '';
        this.itemRecipients = [];
        this.recipientGroups = [];
    }
}

export interface LegislationRecipientVM {
    recipientId: number;
    name: string;
    email: string;
    recipientGroups: LegislationGroup[];
}

export class LegislationRecipientGroup {
    recipientGroupId: number;
    recipientId: number;
    groupId: number;
}

export class LegislationRecipientByGroup {
    groupId: number;
    groupName: string;
    recipients: LegislationRecipientVM[];
}

export interface LegislationGroup {
    groupId: number;
    groupName: string;
}

export interface LegislationItemRecipient {
    itemRecipientId: number;
    recipientId: number;
    legislationItemId: number;
    recipient?: LegislationRecipientVM[];
    leislationItem?: LegislationItem[];
}

export const LGI_COLUMNS = [
    // 'id',
    'title',
    'about',
    'ourPosition',
    'trackingLinks',
    'resourceLinks',
    'emailSubject',
    'subjectOption',
    'talkingPoints',
    'active',
]

export const LGI_SELECTED_COLUMNS = [
    // 'id',
    'title',
    // 'about',
    'active',
]

export const LEGISLATION_RECIPIENTS_COLUMNS = [
    // 'id', 
    'name', 
    'email', 
    'group',
]

export const LEGISLATION_GROUPS_COLUMNS = [
    'groupName',
    'totalRecipients'
]